// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not
export default {
  classifications: state => state.classifications || [],
  classification: state => state.classification || null,
};
